import { render, staticRenderFns } from "./attendanceAuditStaffBindList.vue?vue&type=template&id=20705057&scoped=true"
import script from "./attendanceAuditStaffBindList.vue?vue&type=script&lang=js"
export * from "./attendanceAuditStaffBindList.vue?vue&type=script&lang=js"
import style0 from "./attendanceAuditStaffBindList.vue?vue&type=style&index=0&id=20705057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20705057",
  null
  
)

export default component.exports